import { cn } from "~/lib/utils";

export default function LandingContent({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <div className={cn("mx-auto w-full max-w-[321px] md:max-w-[450px] lg:max-w-[1024px] xl:max-w-[1440px]", className)}>
      {children}
    </div>
  );
}
